import { render } from "./Debug.vue?vue&type=template&id=883b187a&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"

import "./Debug.vue?vue&type=style&index=0&id=883b187a&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883b187a"]])

export default __exports__